<template>
  <div>
    <h5>Customer Feedback Channel</h5>
    <el-switch v-for="(channel, index) in getChannels"
               v-model="channel.selected"
               :active-text="channelFinalName(channel)"
               @change="storeChannelGlobally({channelIndex: index, channelData:channel})"
               style="padding-left: 15px;">
    </el-switch>
  </div>
</template>

<script>
  export default {
    data(){
      return {
      }
    },
    methods: {
      storeChannelGlobally(channelObject){
        this.$store.dispatch('replaceSpecificChannel', channelObject);
      },
      channelFinalName(channelObject){
       return channelObject.meta_value + ' ('+ channelObject.feedback_amount +')';
      }
    },
    computed: {
      getChannels: { //2way binding automatically detects if get or set to use! AWESOME!
        get() {
          return this.$store.getters.getMPPChannels;
        },
        set(value) { //method not used by Element UI ... using change() provided by UI with custom method instead
          this.$store.dispatch('setChannels', value);
        }
      },
      getChannels_Old(){
        return this.$store.getters.getMPPChannels;
      }
    }
  }
</script>

<style scoped lang="scss">

</style>